import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, reactive, resolveComponent, openBlock, createElementBlock, normalizeClass, unref, createVNode, withCtx, createElementVNode, withModifiers, createTextVNode, Fragment, renderList, toDisplayString, normalizeStyle } from 'vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { useStyleConfig } from '../abstract';
import InputNumber from '../input-number/InputNumber.js';
import useThemeStore from './store';
import { Collapse, CollapsePanel, Tooltip } from 'ant-design-vue';
var _hoisted_1 = {
  class: "font-size-name"
};
var _hoisted_2 = {
  class: "font-size-key"
};
var _hoisted_3 = /*#__PURE__*/createElementVNode("div", {
  class: "font-size-xs"
}, null, -1 /* HOISTED */);
var _hoisted_4 = /*#__PURE__*/createElementVNode("div", {
  class: "font-size-sm"
}, null, -1 /* HOISTED */);
var _hoisted_5 = /*#__PURE__*/createElementVNode("div", {
  class: "font-size-lg"
}, null, -1 /* HOISTED */);
var _hoisted_6 = /*#__PURE__*/createElementVNode("div", {
  class: "font-size-xl"
}, null, -1 /* HOISTED */);
var _hoisted_7 = /*#__PURE__*/createElementVNode("div", {
  class: "font-size-xl"
}, null, -1 /* HOISTED */);
var _hoisted_8 = {
  class: "leading-name"
};
var _hoisted_9 = {
  class: "leading-key"
};
var _hoisted_10 = /*#__PURE__*/createElementVNode("span", {
  class: "mr-1"
}, "外间距", -1 /* HOISTED */);
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'SizeEditor',
  setup: function setup(__props) {
    var _useStyleConfig = useStyleConfig('size-editor'),
      prefixCls = _useStyleConfig.prefixCls;
    var _useThemeStore = useThemeStore(),
      theme = _useThemeStore.theme,
      setFont = _useThemeStore.setFont,
      setPadding = _useThemeStore.setPadding,
      setMargin = _useThemeStore.setMargin;
    var font = theme.font,
      padding = theme.padding,
      margin = theme.margin;
    function onFontChange(key, value) {
      setFont(_defineProperty({}, key, value));
    }
    function onPaddingChange(key, value) {
      setPadding(_defineProperty({}, key, value));
    }
    function onMarginChange(key, value) {
      setMargin(_defineProperty({}, key, value));
    }
    var sizeList = [{
      name: '标准字号',
      key: 'font-size'
    }, {
      name: '超小字号',
      key: 'font-size-xs'
    }, {
      name: '小字号',
      key: 'font-size-sm'
    }, {
      name: '大字号',
      key: 'font-size-lg'
    }, {
      name: '加大字号',
      key: 'font-size-xl'
    }, {
      name: '超大字号',
      key: 'font-size-xxl'
    }, {
      name: '特大字号',
      key: 'font-size-xxxl'
    }];
    var lineHeightList = reactive([{
      name: 'LineHeight',
      key: 'leading',
      value: 1.5714285714285714,
      fontSize: '14px'
    }, {
      name: 'LineHeightSM',
      key: 'leading-sm',
      value: 1.6666666666666667,
      fontSize: '12px'
    }, {
      name: 'LineHeightLG',
      key: 'leading-lg',
      value: 1.5,
      fontSize: '16px'
    }, {
      name: 'LineHeightHead1',
      key: 'leading-head-1',
      value: 1.2105263157894737,
      fontSize: '32px'
    }, {
      name: 'LineHeightHead2',
      key: 'leading-head-2',
      value: 1.2666666666666666,
      fontSize: '26px'
    }, {
      name: 'LineHeightHead3',
      key: 'leading-head-3',
      value: 1.3333333333333333,
      fontSize: '22px'
    }, {
      name: 'LineHeightHead4',
      key: 'leading-head-4',
      value: 1.4,
      fontSize: '20px'
    }, {
      name: 'LineHeightHead5',
      key: 'leading-head-5',
      value: 1.5,
      fontSize: '18px'
    }]);
    var paddingList = [{
      name: 'PaddingXXS',
      key: 'xxs'
    }, {
      name: 'PaddingXS',
      key: 'xs'
    }, {
      name: 'PaddingSM',
      key: 'sm'
    }, {
      name: 'PaddingMD',
      key: 'md'
    }, {
      name: 'PaddingLG',
      key: 'lg'
    }, {
      name: 'PaddingXL',
      key: 'xl'
    }];
    var marginList = [{
      name: 'MarginXXS',
      key: 'xxs'
    }, {
      name: 'MarginXS',
      key: 'xs'
    }, {
      name: 'MarginSM',
      key: 'sm'
    }, {
      name: 'MarginMD',
      key: 'md'
    }, {
      name: 'MarginLG',
      key: 'lg'
    }, {
      name: 'MarginXL',
      key: 'xl'
    }];
    return function (_ctx, _cache) {
      var _component_CaretRightFilled = resolveComponent("CaretRightFilled");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass("".concat(unref(prefixCls)))
      }, [createVNode(unref(Collapse), {
        bordered: false,
        "expand-icon-position": "right"
      }, {
        expandIcon: withCtx(function (_ref) {
          var isActive = _ref.isActive;
          return [createVNode(_component_CaretRightFilled, {
            rotate: isActive ? 90 : 0
          }, null, 8 /* PROPS */, ["rotate"])];
        }),
        default: withCtx(function () {
          return [createVNode(unref(CollapsePanel), {
            key: "font"
          }, {
            header: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-font-header"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-font-header-title"))
              }, "文字", 2 /* CLASS */), createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-font-header-input")),
                onClick: _cache[1] || (_cache[1] = withModifiers(function () {}, ["stop"]))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-font-header-input-label"))
              }, "默认字号", 2 /* CLASS */), createVNode(InputNumber, {
                "onUpdate:value": _cache[0] || (_cache[0] = function (val) {
                  return onFontChange('font-size', val);
                }),
                value: unref(font)['font-size'],
                unit: "px",
                size: "small"
              }, null, 8 /* PROPS */, ["value"])], 2 /* CLASS */)], 2 /* CLASS */)];
            }),

            default: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-font"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-font-size"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-font-size-header"))
              }, [createTextVNode(" 字号 "), createVNode(unref(Tooltip), {
                title: "设计系统中使用最广泛的字体大小，文本梯度将基于标准字号进行派生。"
              }, {
                default: withCtx(function () {
                  return [createVNode(unref(QuestionCircleOutlined))];
                }),
                _: 1 /* STABLE */
              })], 2 /* CLASS */), (openBlock(), createElementBlock(Fragment, null, renderList(sizeList, function (item) {
                return createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-font-size-item"))
                }, [createElementVNode("div", null, [createElementVNode("span", _hoisted_1, toDisplayString(item.name), 1 /* TEXT */), createElementVNode("span", _hoisted_2, toDisplayString(item.key), 1 /* TEXT */)]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-font-size-input"))
                }, [createVNode(InputNumber, {
                  "onUpdate:value": function onUpdateValue(val) {
                    return onFontChange(item.key, val);
                  },
                  value: unref(font)[item.key],
                  unit: "px",
                  size: "small"
                }, null, 8 /* PROPS */, ["onUpdate:value", "value"]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-font-size-preview")),
                  style: normalizeStyle("font-size: ".concat(unref(font)[item.key]))
                }, " Aa ", 6 /* CLASS, STYLE */)], 2 /* CLASS */)], 2 /* CLASS */);
              }), 64 /* STABLE_FRAGMENT */)), _hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7], 2 /* CLASS */), createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-leading"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-leading-header"))
              }, [createTextVNode(" 行高 "), createVNode(unref(Tooltip), {
                title: ""
              }, {
                default: withCtx(function () {
                  return [createVNode(unref(QuestionCircleOutlined))];
                }),
                _: 1 /* STABLE */
              })], 2 /* CLASS */), (openBlock(true), createElementBlock(Fragment, null, renderList(lineHeightList, function (item) {
                return openBlock(), createElementBlock("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-leading-item"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-leading-item-name"))
                }, [createElementVNode("span", _hoisted_8, toDisplayString(item.name), 1 /* TEXT */), createElementVNode("span", _hoisted_9, toDisplayString(item.key), 1 /* TEXT */)], 2 /* CLASS */), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-leading-input"))
                }, [createVNode(InputNumber, {
                  size: "small",
                  value: item.value,
                  "onUpdate:value": function onUpdateValue($event) {
                    return item.value = $event;
                  }
                }, null, 8 /* PROPS */, ["value", "onUpdate:value"]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-leading-preview")),
                  style: normalizeStyle("font-size: ".concat(item.fontSize, "; leading: ").concat(item.value))
                }, null, 6 /* CLASS, STYLE */)], 2 /* CLASS */)], 2 /* CLASS */);
              }), 256 /* UNKEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */)];
            }),

            _: 1 /* STABLE */
          }), createVNode(unref(CollapsePanel), {
            key: "padding"
          }, {
            header: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-padding-header"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-padding-header-title"))
              }, "内间距", 2 /* CLASS */), createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = withModifiers(function () {}, ["stop"]))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-padding-header-input-label"))
              }, "基础间距", 2 /* CLASS */), createVNode(InputNumber, {
                value: unref(padding)['base'],
                "onUpdate:value": _cache[2] || (_cache[2] = function (val) {
                  return onPaddingChange('base', val);
                }),
                size: "small",
                unit: "px"
              }, null, 8 /* PROPS */, ["value"])])], 2 /* CLASS */)];
            }),

            default: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-padding"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-padding-title"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-padding-title-name"))
              }, "内间距", 2 /* CLASS */), createVNode(unref(Tooltip), {
                title: "用于控制页面及组件内间距，根据基础间距，就可以派生各种内间距梯度。通过调整基础间距即可得到不同的布局模式，例如紧凑模式下的基础间距为 2 px"
              }, {
                default: withCtx(function () {
                  return [createVNode(unref(QuestionCircleOutlined))];
                }),
                _: 1 /* STABLE */
              })], 2 /* CLASS */), (openBlock(), createElementBlock(Fragment, null, renderList(paddingList, function (item) {
                return createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-item"))
                }, [createElementVNode("div", null, [createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-item-name"))
                }, toDisplayString(item.name), 3 /* TEXT, CLASS */), createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-item-key"))
                }, "padding-" + toDisplayString(item.key), 3 /* TEXT, CLASS */)]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-item-input"))
                }, [createVNode(InputNumber, {
                  unit: "px",
                  value: unref(padding)[item.key],
                  "onUpdate:value": function onUpdateValue(val) {
                    return onPaddingChange(item.key, val);
                  },
                  size: "small"
                }, null, 8 /* PROPS */, ["value", "onUpdate:value"]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-preview"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-preview-box")),
                  style: normalizeStyle("padding: ".concat(unref(padding)[item.key], " 0 0 ").concat(unref(padding)[item.key]))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-padding-preview-box-inner"))
                }, null, 2 /* CLASS */)], 6 /* CLASS, STYLE */)], 2 /* CLASS */)], 2 /* CLASS */)], 2 /* CLASS */);
              }), 64 /* STABLE_FRAGMENT */))], 2 /* CLASS */)];
            }),

            _: 1 /* STABLE */
          }), createVNode(unref(CollapsePanel), {
            key: "margin"
          }, {
            header: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-margin-header"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-margin-header-title"))
              }, "外间距", 2 /* CLASS */), createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = withModifiers(function () {}, ["stop"]))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-margin-header-input-label"))
              }, "基础间距", 2 /* CLASS */), createVNode(InputNumber, {
                value: unref(margin)['base'],
                onClick: _cache[4] || (_cache[4] = withModifiers(function () {}, ["stop"])),
                "onUpdate:value": _cache[5] || (_cache[5] = function (val) {
                  return onMarginChange('base', val);
                }),
                size: "small",
                unit: "px"
              }, null, 8 /* PROPS */, ["value"])])], 2 /* CLASS */)];
            }),

            default: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-margin"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-margin-title"))
              }, [_hoisted_10, createVNode(unref(Tooltip), {
                title: "用于控制页面及组件外间距，根据基础间距，就可以派生各种外间距梯度。通过调整基础外间距即可得到不同的布局模式，例如紧凑模式下的基础间距为 2 px"
              }, {
                default: withCtx(function () {
                  return [createVNode(unref(QuestionCircleOutlined))];
                }),
                _: 1 /* STABLE */
              })], 2 /* CLASS */), (openBlock(), createElementBlock(Fragment, null, renderList(marginList, function (item) {
                return createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-item"))
                }, [createElementVNode("div", null, [createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-item-name"))
                }, toDisplayString(item.name), 3 /* TEXT, CLASS */), createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-item-key"))
                }, toDisplayString(item.key), 3 /* TEXT, CLASS */)]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-item-input"))
                }, [createVNode(InputNumber, {
                  unit: "px",
                  value: unref(margin)[item.key],
                  "onUpdate:value": function onUpdateValue(val) {
                    return onMarginChange(item.key, val);
                  },
                  size: "small"
                }, null, 8 /* PROPS */, ["value", "onUpdate:value"]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-preview"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-preview-box"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-margin-preview-box-inner")),
                  style: normalizeStyle("margin: ".concat(unref(margin)[item.key], " 0 0 ").concat(unref(margin)[item.key], ";height: calc(100% - ").concat(unref(margin)[item.key], "); width: calc(100% - ").concat(unref(margin)[item.key], ");"))
                }, null, 6 /* CLASS, STYLE */)], 2 /* CLASS */)], 2 /* CLASS */)], 2 /* CLASS */)], 2 /* CLASS */);
              }), 64 /* STABLE_FRAGMENT */))], 2 /* CLASS */)];
            }),

            _: 1 /* STABLE */
          })];
        }),

        _: 1 /* STABLE */
      })], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var SizeEditor = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/theme-provider/SizeEditor.js"]]);
export { SizeEditor as default };